import { render, staticRenderFns } from "./couponClassLists.vue?vue&type=template&id=45f51802&scoped=true&"
import script from "./couponClassLists.vue?vue&type=script&lang=js&"
export * from "./couponClassLists.vue?vue&type=script&lang=js&"
import style0 from "./couponClassLists.vue?vue&type=style&index=0&id=45f51802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f51802",
  null
  
)

export default component.exports